import React from 'react'
import heroImage from "../../images/dab83994ae88efb03924f9df75331b9a 1.webp"
import { Link } from 'react-router-dom';

function Section1() {
  return (
    <div className="relative w-full max-w-[1440px] mx-auto px-6 sm:px-8 md:px-12 lg:px-20 xl:px-[120px] xl:mt-[100px] md:pt-[100px] xl:pt-[100px]  sm:pt-[100px]  pt-[50px] pb-24 flex flex-col xl:flex-row xl:items-center gap-12 z-100">

      {/* Left Content (Text) - Slide in from left */}
      <div className="relative z-10 flex flex-col gap-12 w-full xl:max-w-[636px] xl:shrink-0 animate-slide-in-left">
        <div className="flex flex-col gap-6">
          <h1 className="hero-text text-[#006633] font-bold text-[20px] md:text-[56px] leading-[1.2] md:leading-[67px]">
            Advancing Carbon Management for Real-World Impact
          </h1>
          <p className="hero-text text-[#3B3B3B] font-medium text-[28px] leading-[1.4] md:leading-[33px] mb-5">
            We redefine carbon management through real-time monitoring and verified impact empowering individuals and organizations to take credible climate action.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 w-full">
          <a
            href="#plans"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('plans')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="hero-btn group flex justify-center items-center border-2 border-[#E4E7EC] w-full sm:w-auto sm:flex-1 sm:max-w-[306px] h-[56px] bg-[#0D924F] rounded-xl hover:bg-[#0d713f] transition-all cursor-pointer"
          >
            <span className="font-medium text-[24px] text-white text-center">
              Get Started
            </span>
          </a>
          <Link to="/donate" className="hero-btn font-medium text-[24px] text-[#006633]/90 hover:text-white group box-border flex justify-center items-center px-[18px] w-full sm:w-auto sm:flex-1 sm:max-w-[306px] h-[56px] bg-white/80 border rounded-xl hover:bg-[#006633] transition-all cursor-pointer">
              Voluntary Donation
          </Link>
        </div>
      </div>

      {/* Right Content (Image) - Slide in from right */}
      <img
        fetchPriority="high"
        className="hero-image-container w-full max-w-[500px] h-auto mx-auto object-contain z-0 pointer-events-none animate-slide-in-right xl:absolute xl:inset-y-0 xl:right-0 xl:mx-0 xl:h-full xl:w-[556px] xl:max-w-[calc(100%-780px)] xl:object-contain xl:object-right"
        src={heroImage}
        alt="Carbon Management"
      />
    </div>
  )
}

export default Section1